import React, {PureComponent} from 'react';
import {fromLonLat} from "ol/proj";
import Map from "ol/Map";
import TileLayer from "ol/layer/Tile";
import XYZ from "ol/source/XYZ";
import View from "ol/View";
import $ from "jquery";
import Overlay from "ol/Overlay";
import {formatTime} from "../functions/utils";
import LineChart from "../independentComponents/graphComponent";
import flagIcon from "../../img/marshall.png";
import ReactTooltip from "react-tooltip";
import Feature from "ol/Feature";
import LineString from "ol/geom/LineString";
import Style from "ol/style/Style";
import Stroke from "ol/style/Stroke";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import parallel from "async/parallel";
import waterfall from "async/waterfall";
import {withTranslation} from "react-i18next";
import {withCookies} from "react-cookie";
import Alert from "react-s-alert";

import Moment from "moment-timezone";

const serverIP = process.env.REACT_APP_SERVER_IP;
const backendPort = process.env.REACT_APP_BACKEND_PORT;

const telemetryIP = process.env.REACT_APP_TELEMETRY_IP;
const telemetryPort = process.env.REACT_APP_MESSAGE_PORT;

const super_admin = parseInt(process.env.REACT_APP_SUPER_ADMIN_ID);
const admin = parseInt(process.env.REACT_APP_EVENT_ADMIN_ID);
const sub_admin = parseInt(process.env.REACT_APP_EVENT_SUB_ADMIN_ID);

class PopoutLapDetail extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            header: <div/>,
            lap: null,
            adjacentLaps: [null, null],
            showPercent: 0,
            carMarker: null,
            telemetryMinMax: {},
            hardBrakingColor: '#ff0000',
            mildBrakingColor: '#ffad40',
            slightSpeedDecrease: '#91ceff',
            fullGasColor: '#00e02e',
            halfGasColor: '#d5ff5f',
            liftColor: '#ffffff',
            privileges: [],
            orderedMetrics: [],
            rpmTag: "",
            speedTag: "",
        };

        this.getLapInfo = this.getLapInfo.bind(this);
        this.getSessionDetails = this.getSessionDetails.bind(this);
        this.getUserPrivileges = this.getUserPrivileges.bind(this);
        this.setupMap = this.setupMap.bind(this);
        this.calcMaxes = this.calcMaxes.bind(this);
        this.updateShow = this.updateShow.bind(this);
        this.putSectorMarkers = this.putSectorMarkers.bind(this);
        this.makeLapHeader = this.makeLapHeader.bind(this);
        this.handleChangeLap = this.handleChangeLap.bind(this);
        this.getAdjacentLaps = this.getAdjacentLaps.bind(this);
        this.highlightMapAnalysis = this.highlightMapAnalysis.bind(this);
        this.sortMetrics = this.sortMetrics.bind(this);
        this.handleRequestBulkData = this.handleRequestBulkData.bind(this);
    }

    componentDidMount() {
        $(".loading").fadeIn();
        parallel([
            (p_callback) => {
                this.getSessionDetails((status) => {
                    this.setupMap((status) => {
                        p_callback(null, status);
                    });
                });
            },
            (p_callback) => {
                this.getUserPrivileges((status) => {
                    p_callback(null, status);
                });
            },
            (p_callback) => {
                this.getLapInfo(null, (status) => {
                    p_callback(null, status);
                });
            }
        ], (err, result) => {
            console.log("[LAP DETAIL] static/initial data fetch COMPLETED");
        });
    }

    /* GET DATA */
    getAdjacentLaps(lapUUID, callback) {
        this.setState({
            adjacentLaps: [],
        });
        const helper = this;
        $.ajax({
            type: 'POST',
            url: serverIP + ':' + backendPort + '/dashboard/getAdjacentLaps',
            dataType: 'json',
            headers: {
                'authorization': helper.props.cookies.get("authToken")
            },
            data: {
                lapUUID: lapUUID,
                carID: helper.state.lap[0].car_id,
                sessionID: helper.state.lap[0].session_id,
            },
            success: function (data) {
                helper.setState({
                    adjacentLaps: data
                }, () => {
                    callback("ok");
                });
            },
            error: function (err) {
                if (err) {
                    console.error('Error:', err);
                }
                callback("nok");
            }
        });
    }

    getLapInfo(lap, callback) {
        $(".loading").fadeIn();
        const helper = this;
        waterfall([
                function (w_callback) {
                    $.ajax({
                        type: 'POST',
                        url: serverIP + ':' + backendPort + '/dashboard/getLapFullDetails',
                        dataType: 'json',
                        headers: {
                            'authorization': helper.props.cookies.get("authToken")
                        },
                        data: {
                            lapUUIDs: lap ? lap.uuid : helper.props.match.params.lapUUID,
                        },
                        success: function (data) {
                            if (data && data.length === 1 && data[0][0] && data[0][1]) {
                                helper.setState({
                                    lap: data[0],
                                    orderedMetrics: [],
                                }, () => {
                                    w_callback(null, "ok");
                                });
                            } else {
                                $(".loading").fadeOut();
                                Alert.error('<span style="font-family: \'Iceland\',serif; font-weight: bold; font-size: 20px;white-space: normal;">' + helper.props.t("noLapTelemetry") + '!</span>', {
                                    position: 'top-right',
                                    effect: 'genie',
                                    beep: true,
                                    timeout: 20000,
                                    offset: 150
                                });
                                w_callback(null, "nok");
                            }
                        },
                        error: function (err) {
                            if (err) {
                                console.error('Error:', err);
                                $(".loading").fadeOut();
                                Alert.error('<span style="font-family: \'Iceland\',serif; font-weight: bold; font-size: 20px;white-space: normal;">' + helper.props.t("noLapTelemetry") + '!</span>', {
                                    position: 'top-right',
                                    effect: 'genie',
                                    beep: true,
                                    timeout: 20000,
                                    offset: 150
                                });
                            }
                            w_callback(null, "nok");
                        }
                    });
                },
                function (prev_status, w_callback) {
                    if (prev_status === "nok") {
                        w_callback(true, prev_status);
                    } else {
                        helper.getAdjacentLaps(lap ? lap.uuid : helper.props.match.params.lapUUID, (inner_status) => {
                            w_callback((prev_status === "ok") ? null : true, inner_status);
                        });
                    }
                }
            ], function (err, result) {
                if (err) {
                    $(".loading").fadeOut();
                    if (callback) {
                        callback("nok");
                    }
                } else {
                    parallel([
                        function (p_callback) {
                            helper.makeLapHeader((status) => {
                                p_callback(null, status);
                            });
                        },
                        function (p_callback) {
                            helper.sortMetrics((status) => {
                                p_callback(null, status);
                            });
                        },
                        function (p_callback) {
                            helper.calcMaxes((status) => {
                                p_callback(null, status);
                            });
                        },
                        function (p_callback) {
                            helper.highlightMapAnalysis((status) => {
                                p_callback(null, status);
                            });
                        },
                        function (p_callback) {
                            helper.putSectorMarkers((status) => {
                                p_callback(null, status);
                            });
                        },
                    ], (err, result) => {
                        $(".loading").fadeOut();
                        if (callback) {
                            callback("ok");
                        }
                    });
                }
            }
        );
    }

    getSessionDetails(callback) {
        const helper = this;
        $.ajax({
            type: 'POST',
            url: serverIP + ":" + backendPort + '/dashboard/getSessionDetails',
            headers: {
                'authorization': helper.props.cookies.get("authToken"),
            },
            data: {
                sessionID: helper.props.match.params.sessionID,
            },
            success: function (data) {
                if (data) {
                    helper.setState({
                        session: data.session,
                        circuit: data.circuit,
                        lengthType: data.length_delimiter,
                        orderType: data.order_factor,
                        eventLength: data.length,
                        circuitLength: data.track_length,
                        circuitTimezone: data.timezone,
                        startTimestamp: (data.start_timestamp ? data.start_timestamp : data.scheduled_start_timestamp),
                        mapCenterLat: data.map_center_lat,
                        mapCenterLng: data.map_center_lng,
                        mapZoomLevel: data.map_center_zoom_level,
                        mapRotation: data.map_rotation,
                    }, () => {
                        callback("ok");
                    });
                }
            }, error: function (err) {
                if (err) {
                    console.error('Error:', err);
                }
                callback("nok");
            }
        });
    }

    getUserPrivileges(callback) {
        const helper = this;
        $.ajax({
            type: 'POST',
            url: serverIP + ':' + backendPort + '/dashboard/getUserPrivileges',
            dataType: 'json',
            headers: {
                'authorization': helper.props.cookies.get("authToken")
            },
            data: {
                carID: helper.state.carID,
            },
            success: function (data) {
                helper.setState({
                    privileges: data["privileges"],
                    isOwnTeam: data["isOwnTeam"]
                }, () => {
                    callback("ok");
                });
            },
            error: function (err) {
                if (err) {
                    console.error('Error:', err);
                }
                callback("nok");
            }
        });
    }

    /* SETUP */
    putSectorMarkers(callback) {
        const helper = this;
        $.ajax({
            type: 'POST',
            url: serverIP + ':' + backendPort + '/dashboard/getSectorInfo',
            dataType: 'json',
            headers: {
                'authorization': helper.props.cookies.get("authToken")
            },
            data: {
                eventID: helper.props.match.params.sessionID
            },
            success: function (data) {
                if (data.length > 0) {
                    let currentSector = 0;
                    for (let i = 0; i < data.length; i++) {

                        let flagText = '';
                        if ([0, 3, 6].includes(data[i].order_no)) {
                            currentSector++;
                            flagText = 'P' + (data[i].order_no + 1) + ' / S' + currentSector;
                        } else {
                            flagText = 'P' + (data[i].order_no + 1);
                        }

                        let innerDiv = $('' +
                            '<div class="sectorFlag" style="height: 55px;width: 65px;">' +
                            '<span class="sectorText" style="font-size: 11px">' + flagText + ' </span>' +
                            '<img style="height: 100%; width:100%" src="' + flagIcon + '" alt="sector"/>' +
                            '</div>' +
                            '').get(0);

                        helper.map.addOverlay(
                            new Overlay({
                                id: "sector_" + (i + 1),
                                element: innerDiv,
                                position: fromLonLat([data[i].internal_point_lng, data[i].internal_point_lat]),
                                offset: [-2, 4],
                                positioning: 'bottom-left',
                            })
                        );
                    }
                    callback("ok");
                } else {
                    callback("nok");
                }
            },
            error: function (err) {
                if (err) {
                    console.error('Error:', err);
                }
                callback("nok");
            }
        });
    }

    setupMap(callback) {
        this.map = new Map({
            target: "map",
            layers: [
                new TileLayer({
                    source: new XYZ({
                        attributions: 'Tiles © <a href="https://services.arcgisonline.com/arcgis/rest/services/World_Imagery/MapServer">ArcGIS</a>',
                        url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'
                    })
                }),
            ],
            view: new View({
                center: fromLonLat([this.state.mapCenterLng, this.state.mapCenterLat]),
                zoomFactor: 1.1,
                zoom: this.state.mapZoomLevel - 3,
                maxZoom: 141,
                rotation: this.state.mapRotation,
            }),
            loadTilesWhileAnimating: true,
            loadTilesWhileInteracting: true,
        });

        const innerDiv = $('' +
            '<div id="car_id_marker">' +
            '   <span class="fa-stack carPin">' +
            '       <i class="fa fa-circle fa-stack-2x" style="color: #b00b0d;line-height: inherit;"/><i class="fa fa-car fa-stack-1x fa-inverse" style="font-size:15px;margin:inherit"/>' +
            '   </span>' +
            '</div>').get(0);

        this.setState({
            marker: new Overlay({
                id: "carMarker_Details",
                element: innerDiv,
                position: fromLonLat([0, 0]),
                offset: [0, 10],
                positioning: 'bottom-center',
            })
        }, () => {
            this.map.addOverlay(this.state.marker);
            callback("ok");
        });
    }

    calcMaxes(callback) {
        let telemetry_min_max = {};
        Object.keys(this.state.lap[1].labels).forEach((tag) => {
            if (this.state.lap[1].data[tag].length > 0) {
                let min = Math.min(...this.state.lap[1].data[tag]);
                let max = Math.max(...this.state.lap[1].data[tag]);
                telemetry_min_max[tag] = (min === max ? [0, 0] : [min, max]);
            } else {
                telemetry_min_max[tag] = [0, 0];
            }

            if (this.state.lap[1].labels[tag].en.toUpperCase().indexOf("RPM") >= 0) {
                this.setState({
                    rpmTag: tag,
                });
            }
            if (this.state.lap[1].labels[tag].en.toUpperCase().indexOf("SPEED") >= 0) {
                this.setState({
                    speedTag: tag,
                });
            }
        });
        this.setState({
            telemetryMinMax: telemetry_min_max,
        }, () => {
            callback("ok");
        });
    }

    highlightMapAnalysis(callback) {
        if (this.state.lap !== null) {
            this.map.getLayers().forEach((layer) => {
                if (layer.get('name') === "analysis") {
                    layer.getSource().clear();
                }
            });

            let convertedCoords = [];

            for (let i = 0; i < this.state.lap[1].data.coords.length; i++) {
                convertedCoords.push(
                    fromLonLat([this.state.lap[1].data.coords[i][0], this.state.lap[1].data.coords[i][1]])
                );
            }

            for (let i = 0; i < convertedCoords.length; i++) {

                let feature = null;
                if (i === 0) {
                    feature = new Feature({
                        geometry: new LineString([convertedCoords[convertedCoords.length - 1], convertedCoords[0]]),
                        name: 'Line',
                    });
                } else {
                    feature = new Feature({
                        geometry: new LineString([convertedCoords[i - 1], convertedCoords[i]]),
                        name: 'Line',
                    });
                }

                let color = "#000000";
                if (this.state.lap[1].data.poly[i].braking > 0) {
                    if (this.state.lap[1].data.poly[i].braking === 1) {
                        color = this.state.mildBrakingColor;
                    } else if (this.state.lap[1].data.poly[i].braking === 2) {
                        color = this.state.hardBrakingColor;
                    } else if (this.state.lap[1].data.poly[i].braking === 3) {
                        color = this.state.slightSpeedDecrease;
                    }
                } else if (this.state.lap[1].data.poly[i].accell > 0) {
                    if (this.state.lap[1].data.poly[i].accell === 1) {
                        color = this.state.liftColor;
                    } else if (this.state.lap[1].data.poly[i].accell === 2) {
                        color = this.state.halfGasColor;
                    } else if (this.state.lap[1].data.poly[i].accell === 3) {
                        color = this.state.fullGasColor;
                    }
                } else {
                    color = "#000000";
                }

                let style = new Style({
                    stroke: new Stroke({
                        lineCap: "round",
                        lineJoin: "round",
                        width: 9,
                        color: color,
                    }),
                });

                feature.setId(i);
                feature.setStyle(style);

                let layerLines = new VectorLayer({
                    name: "analysis",
                    source: new VectorSource({
                        features: [feature]
                    }),
                });

                this.map.addLayer(layerLines);
            }
            callback("ok");
        }
    }

    sortMetrics(callback) {
        let array = [];

        if (this.state.lap[1].labels !== undefined && this.state.lap[1].labels !== null) {

            // Insert MONGO label on metric object for later
            for (let i = 0; i < Object.keys(this.state.lap[1].labels).length; i++) {
                let temp = this.state.lap[1].labels[Object.keys(this.state.lap[1].labels)[i]];
                temp["label"] = Object.keys(this.state.lap[1].labels)[i];
                array.push(temp);
            }
            // Filter null objects
            let filtered = array.filter(function (el) {
                return el != null;
            });

            // Sort by order_no
            filtered.sort(function (a, b) {
                if (a.order_no > b.order_no) {
                    return 1;
                }
                if (a.order_no < b.order_no) {
                    return -1;
                }
                // a must be equal to b
                return 0;
            });

            // Sort by type (base/extra)
            filtered.sort(function (a, b) {
                if (a.type > b.type) {
                    return 1;
                }
                if (a.type < b.type) {
                    return -1;
                }
                // a must be equal to b
                return 0;
            });

            // Extract the Mongo labels from the ordered metrics
            let final = [];
            for (let i = 0; i < filtered.length; i++) {
                final.push(filtered[i].label);
            }

            this.setState({
                orderedMetrics: final,
            }, () => {
                callback("ok");
            });
        }
    }

    /* HANDLERS */
    handleChangeLap(e) {
        let action = e.target.value;
        switch (action) {
            case "next": {
                this.getLapInfo(this.state.adjacentLaps[1], null);
                break;
            }
            case "previous": {
                this.getLapInfo(this.state.adjacentLaps[0], null);
                break;
            }
            default: {
                break;
            }
        }
    }

    handleRequestBulkData(e) {
        const helper = this;
        $.ajax({
            type: 'POST',
            url: telemetryIP + ':' + telemetryPort + '/command-worker-device?command=RT-DEV-LOG-DATA-READ-REQUEST&carId=' + helper.state.lap[0].car_id,
            headers: {
                'Authorization': 'Basic ' + btoa('admin:vZ3s4T7MJfWhHD5H')
            },
            contentType: 'application/json',
            dataType: 'json',
            data: JSON.stringify({
                payload: {
                    start: (helper.state.lap[0].registry_timestamp - helper.state.lap[0].time),
                    end: helper.state.lap[0].registry_timestamp
                }
            }),
            success: function () {
                console.log('Successfully sent session car data log request.');
                Alert.success('<span style="font-family: \'Iceland\',serif; font-weight: bold; font-size: 20px;white-space: normal;">' + helper.props.t("bulkSuccess") + '!</span>', {
                    position: 'top-right',
                    effect: 'genie',
                    beep: true,
                    timeout: 20000,
                    offset: 150
                });
            },
            error: function (err) {
                console.error('Error sending session car data log request.');
                Alert.error('<span style="font-family: \'Iceland\',serif; font-weight: bold; font-size: 20px;white-space: normal;">' + helper.props.t("bulkError") + '!</span>', {
                    position: 'top-right',
                    effect: 'genie',
                    beep: true,
                    timeout: 20000,
                    offset: 150
                });
            }
        });
    }

    updateShow(index) {
        let ratio = 0;
        if (this.state.rpmTag !== undefined && this.state.rpmTag !== null && this.state.rpmTag.length > 0) {
            ratio = (Math.round((this.state.lap[1].data[this.state.speedTag][index] / (this.state.lap[1].data[this.state.rpmTag][index] / 1000)) * 10) / 10).toFixed(1);
        }
        this.state.marker.setPosition(
            fromLonLat([
                this.state.lap[1].data.coords[index][0],
                this.state.lap[1].data.coords[index][1]
            ])
        );
        this.setState({
            ratio: (isFinite(ratio) ? ratio : 0),
        });
    }

    /* RENDER */
    makeLapHeader(callback) {
        this.setState({
            header: (
                <div className={"App_ContainerStyle col-xs-12 col-lg-5"} style={{padding: 0}}>
                    <div className={"col-sm-12 col-md-5 col-lg-12 clearfix"}>
                        <div className={"col-xs-3 col-sm-3"} style={{margin: 0, padding: 0}}>
                            <img className={"img-responsive"}
                                 alt={"PIC"}
                                 src={(this.state.lap[0].driver_pic_path) ? (serverIP + ":" + backendPort + "/uploads/drivers/" + this.state.lap[0].driver_pic_path.photo_path) : (serverIP + ":" + backendPort + "/uploads/noimage.png")}
                            />
                        </div>
                        <div className={"col-xs-9 col-sm-9"}>
                            <span className={"App_white_text"}>{this.state.lap[0].driver_name}</span> <span className={"App_white_text"} style={{color: "#ff0012"}}>{this.state.lap[0].driver_nationality}</span><br/>
                            <span className={"App_white_text"}><b style={{color: "#ff0012"}}>#{this.state.lap[0].livery_number}</b> {this.state.lap[0].team_name}</span><br/><br/>
                            <div className={"col-xs-12"} style={{margin: 0, padding: 0}}>
                                <span className={"App_white_text"}><b style={{color: "#ff0012"}}>{this.props.t("recordedAt")}</b></span><br/>
                                <span className={"App_streamText"}><b>{Moment(this.state.lap[0].registry_timestamp).tz(this.state.circuitTimezone).format("DD/MM/YYYY | HH:mm:ss")}</b></span><br/>
                            </div>
                            <div className={"col-xs-12 col-sm-4"} style={{margin: 0, padding: 0}}>
                                <span className={"App_white_text"}><b style={{color: "#ff0012"}}>{this.props.t("lap")} {this.state.lap[0].lap_number}</b></span><br/>
                                <span className={"App_streamText"}>{formatTime(this.state.lap[0].time)}</span><br/>
                            </div>
                            <div className={"col-xs-12 col-sm-8"}>
                                <button
                                    data-tip={true}
                                    data-for={"previousLap"}
                                    className={"btn App_white_text button"}
                                    style={{background: "#ff0003", fontWeight: "bold"}}
                                    type={"button"}
                                    value={"previous"}
                                    disabled={!this.state.adjacentLaps[0]}
                                    onClick={this.handleChangeLap}
                                >
                                    <i className={"fas fa-angle-double-left"}/>
                                </button>
                                <ReactTooltip id={"previousLap"} type={"light"}>
                                    <span className={"toolTipStyle"}>{this.props.t("previousLap")}</span>
                                </ReactTooltip>
                                <button
                                    data-tip={true}
                                    data-for={"nextLap"}
                                    className={"btn App_white_text button"}
                                    style={{background: "#ff0003", fontWeight: "bold", marginLeft: 10}}
                                    type={"button"}
                                    value={"next"}
                                    disabled={!this.state.adjacentLaps[1]}
                                    onClick={this.handleChangeLap}
                                >
                                    <i className={"fas fa-angle-double-right"}/>
                                </button>
                                <ReactTooltip id={"nextLap"} type={"light"}>
                                    <span className={"toolTipStyle"}>{this.props.t("nextLap")}</span>
                                </ReactTooltip>
                                {((this.state.lap[0].conn_type === '4G') && this.state.lap[0].has_bulk === 0 && !(this.state.privileges.includes(super_admin) || this.state.privileges.includes(admin) || this.state.privileges.includes(sub_admin))) ? (
                                    <>
                                        <button
                                            data-tip={true}
                                            data-for={"bulkData"}
                                            className={"btn App_white_text button"}
                                            style={{background: "#ff0003", fontWeight: "bold", float: "right"}}
                                            type={"button"}
                                            onClick={this.handleRequestBulkData}
                                        >
                                            <i className={"fas fa-cloud-download-alt"}/>
                                        </button>
                                        <ReactTooltip id={"bulkData"} type={"light"}>
                                            <span className={"toolTipStyle"}>{this.props.t("requestBulkData")}</span>
                                        </ReactTooltip>
                                    </>
                                ) : null}
                            </div>
                        </div>
                    </div>
                    <div className={"col-sm-12 hidden-md"}>
                        <hr style={{margin: 8, padding: 0}}/>
                    </div>
                    <div className={"col-md-7 col-lg-12"} style={{marginBottom: 15}}>
                        <div className={"col-xs-12 col-sm-4"}>
                            <span className={"App_white_text"}><b style={{color: "#ff0012"}}>{this.props.t("maxSpd")} (OBD): </b>
                                {!this.state.lap[0].max_speed_obd || this.state.lap[0].max_speed_obd > 500 ? "---" : this.state.lap[0].max_speed_obd + " km/h"}
                            </span>
                            <br/>
                            <span className={"App_white_text"}><b style={{color: "#ff0012"}}>{this.props.t("maxSpd")} (GPS): </b>
                                {!this.state.lap[0].max_speed_gps || this.state.lap[0].max_speed_gps > 500 ? "---" : this.state.lap[0].max_speed_gps + " km/h"}
                            </span>
                            <br/>
                            <span className={"App_white_text"}><b style={{color: "#ff0012"}}>{this.props.t("maxEngTemp")}: </b>
                                {!this.state.lap[0].max_eng_temp || this.state.lap[0].max_eng_temp > 500 ? "---" : this.state.lap[0].max_eng_temp + " ºC"}
                            </span>
                        </div>
                        <div className={"col-xs-12 col-sm-4"}>
                            <span className={"App_white_text"}><b style={{color: "#ff0012"}}>{this.props.t("minSpd")} (OBD): </b>
                                {!this.state.lap[0].min_speed_obd || this.state.lap[0].min_speed_obd > 500 ? "---" : this.state.lap[0].min_speed_obd + " km/h"}
                            </span>
                            <br/>
                            <span className={"App_white_text"}><b style={{color: "#ff0012"}}>{this.props.t("minSpd")} (GPS): </b>
                                {!this.state.lap[0].min_speed_gps || this.state.lap[0].min_speed_gps > 500 ? "---" : this.state.lap[0].min_speed_gps + " km/h"}
                            </span>
                        </div>
                        <div className={"col-xs-12 col-sm-4"}>
                            <span className={"App_white_text"}><b style={{color: "#ff0012"}}>{this.props.t("maxRpm_thr")}: </b>
                                {!this.state.lap[0].max_throttled_rpm || this.state.lap[0].max_throttled_rpm > 50000 ? "---" : this.state.lap[0].max_throttled_rpm}
                            </span>
                            <br/>
                            <span className={"App_white_text"}><b style={{color: "#ff0012"}}>{this.props.t("maxRpm_noThr")}: </b>
                                {!this.state.lap[0].max_rpm || this.state.lap[0].max_rpm > 50000 ? "---" : this.state.lap[0].max_rpm}
                            </span>
                        </div>
                    </div>
                </div>
            )
        }, () => {
            callback("ok");
        });
    }

    render() {
        return (
            <div className={"container-fluid"}>
                <Alert stack={{limit: 10}} html={true}/>
                <div className="loading">
                    <div className={"loading-text hidden-sm hidden-xs"}>{this.props.t("processing")}</div>
                </div>
                <div className={"row w3-animate-fading"} style={{margin: 10}}>
                    {this.state.header}
                    <div className={"col-xs-12 col-sm-12 col-lg-7"}>
                        <div style={{
                            marginLeft: 15,
                            height: 320,
                        }} id={"map"}/>
                        <span className={"App_smallHeader"}>
                            <b style={{color: "#FFFFFF"}}>{this.props.t("legend").toUpperCase()}: </b> <b style={{color: this.state.hardBrakingColor}}>{this.props.t("hardBraking")}</b> | <b style={{color: this.state.mildBrakingColor}}>{this.props.t("mildBraking")}</b> | <b style={{color: this.state.slightSpeedDecrease}}>{this.props.t("slightSpeedDecrease")}</b> | <b style={{color: this.state.fullGasColor}}>{this.props.t("fullGas")}</b> | <b
                            style={{color: this.state.halfGasColor}}>{this.props.t("halfGas")}</b> | <b style={{color: this.state.liftColor}}>{this.props.t("lift")}</b>
                        </span>
                    </div>
                </div>
                {this.state.lap && this.state.lap.length > 0 ? (
                    <div className={"row"}>
                        <div id={"mainTable"} className={"table-scroll-parent"} style={{height: "75vh"}}>
                            <div className={"table-scroll-child"}>
                                {this.state.orderedMetrics.length > 0 ? this.state.orderedMetrics.map((tag) => {
                                    if (Object.keys(this.state.telemetryMinMax).length > 0 && this.state.telemetryMinMax[tag][1] > 0) {
                                        return (
                                            <div className={this.state.lap[0].has_bulk === 1 ? "col-md-12" : "col-md-6"} key={"graph_" + tag}>
                                                <LineChart
                                                    dataName={this.state.lap[1].labels[tag][localStorage.getItem("i18nextLng")]}
                                                    data={this.state.lap[1].data[tag]}
                                                    additionalData={this.state.lap[1].labels[tag].en === "RPM" ? this.state.ratio : false}
                                                    hoverTriggerIndex={[true, false]}
                                                    minYAxis={this.state.lap[1].labels[tag].unit === "%" ? 0 : this.state.telemetryMinMax[tag][0]}
                                                    maxYAxis={this.state.lap[1].labels[tag].unit === "%" ? 100 : this.state.telemetryMinMax[tag][1]}
                                                    unit={this.state.lap[1].labels[tag].unit}
                                                    showPercent={this.state.showPercent}
                                                    updateShow={this.updateShow}
                                                />
                                            </div>
                                        );
                                    } else {
                                        return null;
                                    }
                                }) : null}
                            </div>
                        </div>
                    </div>
                ) : (
                    <div/>
                )}
            </div>
        );
    }
}

export default withTranslation("translations")(withCookies(PopoutLapDetail));
